import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

// @ts-expect-error - imported from .js/.jsx file
import {ReplyClockIcon} from 'shells/icon/svg/reply-clock-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {GetAgents_chatAgents as Agent} from 'nutshell-graphql-types';

import {buildNeedsReplyAssigneeUrl} from '../helpers';

import styles from './needs-reply-pill.module.css';

type Props = {
    agent: Agent;
};

export function NeedsReplyPill(props: Props) {
    return (
        <Link
            // @ts-expect-error
            as={RoutedLink}
            variant='secondary'
            size='small'
            to={buildNeedsReplyAssigneeUrl(props.agent.id)}
        >
            <div
                title={
                    props.agent.numNeedsReplyChats > 1
                        ? `${props.agent.numNeedsReplyChats} chats need reply`
                        : '1 chat needs reply'
                }
                className={styles['pill-container']}
            >
                <ReplyClockIcon alignCenter={true} size={15} />
                <Body>{props.agent.numNeedsReplyChats}</Body>
            </div>
        </Link>
    );
}
